import { createSelector } from 'reselect';

export const getIds = ({ orderProduct }) => orderProduct.list.allIds;
export const getById = ({ orderProduct }) => orderProduct.byId;
export const getOrderProduct = (state, id) => state.orderProduct.byId[id];
export const getOrderProductList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));
